module.exports = __webpack_public_path__ + "img/cert-sqs.c16e076f.svg";